<template>
  <div class="input-container">
    <label
      v-if="!inputFocused && !data"
      class="v-label p-2"
      style="left: 12px; top: 10px; position: absolute; pointer-events: none; color: #00000099"
      :class="{ 'error--text': !!errorText }"
      >{{ label || 'dd/mm/yyyy' }}
    </label>
    <MaskedInput
      :disabled="disabled"
      v-bind="this.$attrs"
      v-model="data"
      mask="11/11/1111"
      class="input mr-1 pa-2"
      @focus.native="inputFocused = true"
      @blur.native="inputFocused = false"
      :class="{ 'input--error': !!errorText }"
    />
    <VMessages v-if="errorText" class="caption error--text pl-3 error-text" :value="[errorText]" color="error" />
  </div>
</template>

<script>
import moment from 'moment'
import MaskedInput from 'vue-masked-input'
import VInput from 'vuetify/lib/components/VInput/VInput.js'

export default {
  extends: VInput,
  props: {
    date: String,
    // rules: {
    //   type: Array,
    //   default: () => []
    // },
    // hideDetails: {
    //   type: Boolean,
    //   default: false
    // },
    label: String,
    disabled: Boolean,
  },
  components: {
    MaskedInput,
  },

  data: () => ({
    data: '',
    menu: false,
    errorText: '',
    inputFocused: false,
  }),

  methods: {
    validate(force) {
      // overide validate VInput
      if (force) {
        this.updated(this.data)
      }

      return !this.errorText
    },
    updated(value) {
      if (this.rules && this.rules.length) {
        let errorText = ''
        for (const rule of this.rules) {
          errorText = rule(value)
          if (errorText !== true) break
        }
        if (errorText !== true) this.errorText = errorText
        else this.errorText = null
      }

      if (value) {
        const isoDate = !this.errorText ? moment(this.data, 'DD/MM/YYYY').toISOString() : ''
        this.$emit('update:date', isoDate)
        this.$emit('input', isoDate)
      } else {
        this.$emit('update:date', '')
        this.$emit('input', '')
      }
      this.menu = false
    },
    reset() {
      if (this.date) {
        this.data = moment(this.date).format('DD/MM/YYYY')
      } else {
        this.data = ''
      }
    },
    onEnterPress() {
      this.$emit('onEnterPress')
    },
  },
  created() {
    this.reset()
  },
  watch: {
    data() {
      this.updated(this.data)
    },
    date(newValue) {
      if (newValue) {
        this.data = moment(newValue).format('DD/MM/YYYY');
      } else {
        this.data = '';
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.input-container {
  position: relative;
}
.input {
  width: 100%;
  border: 1px solid #aaa;
  border-radius: 4px;
  outline: none;
  padding: 7px 8px;
  box-sizing: border-box;
}

.input:focus {
  border: 2px solid #0d47a1;
  padding: 6px 7px;
}

.input--error {
  border: 2px solid #b71c1c !important;
  padding: 6px 7px;
}
.error-text {
  margin-top: 2px;
  min-height: 14px;
  // line-height: 14px;
  margin-bottom: -4px;
}
</style>
